import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import React from "react";
import "./style.css";

const CircleButton = props => {
  const { onClick, tooltip, icon } = props;

  return (
    <Tooltip placement="top" color={"#005075"} title={tooltip ? tooltip : ""}>
      <div className="vapor-circleButton" onClick={onClick || null}>
        <FontAwesomeIcon
          icon={icon}
          style={{ fontSize: "23px", color: "white", margin: "0 auto" }}
        />
      </div>
    </Tooltip>
  );
};

export default CircleButton;
